/// <reference types="@angular/localize" />
import * as Sentry from "@sentry/angular";
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { appVersion } from "./environments/version";

if (environment.production) {
  //https://medium.com/techsoplaya/how-to-add-sentry-to-your-angular-app-and-integrate-it-into-gitlab-ci-cd-96fe84befc89
  Sentry.init({
    environment: environment.production == true && environment.isStaging == false? 'production' : 'staging',
    release: 'quick-planner-frontend@' + appVersion.version,
    dsn: environment.sentry_dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: environment.production ? 0.2 : 1,

      // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
